// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE

import * as React from "react";

require("./Button.css");

function Button(Props) {
  var children = Props.children;
  var match = Props.onClick;
  var onClick = match !== undefined ? match : (function (_e) {
        return /* () */0;
      });
  return React.createElement("button", {
              className: "xuder-button",
              onClick: onClick
            }, children);
}

var make = Button;

export {
  make ,
  
}
/*  Not a pure module */
